module.exports = __webpack_public_path__ + "static/media/panel2.c7592247.jpg";